import type { ParsedUrlQuery } from 'querystring';

import { PARTNERS } from '@/constants/partners';

export const readFirstQueryValue = (
  value: ParsedUrlQuery[string],
): string | undefined => {
  const values: readonly (string | undefined)[] = Array.isArray(value)
    ? value
    : [value];
  return values.find((entry) => entry?.trim());
};

export const isCloseknitReferral = (query?: ParsedUrlQuery): boolean => {
  const referrerId = readFirstQueryValue(query?.referrer_id);
  const referrerName = readFirstQueryValue(query?.referrer_name);
  const referringPractice = readFirstQueryValue(query?.referring_practice);

  return (
    referrerId?.toLowerCase() === PARTNERS.Closeknit.referrer_id ||
    referrerName?.toLowerCase() === PARTNERS.Closeknit.referrer_name ||
    referringPractice?.toLowerCase() === PARTNERS.Closeknit.referrer_id ||
    referringPractice?.toLowerCase() === PARTNERS.Closeknit.referrer_name
  );
};
